import PropTypes from 'prop-types'

import FormattedDateRange from 'components/FormattedDateRange'
import Link from 'components/Link'
import Text from 'components/Text'

import { LocationBadge, Root } from './UpcomingTrunkShow.style'
import HK from './svg/hk-x.svg'
import NY from './svg/ny-x.svg'
import SH from './svg/sh-x.svg'

const locationBadges = {
  HK: HK,
  SH: SH,
  NY: NY,
}

const UpcomingTrunkShow = ({ handle, locationBadge, startDate, endDate }) => {
  const badge = locationBadges?.[locationBadge]

  return (
    <Root>
      {badge && <LocationBadge>{badge({ viewBox: '0 0 437.6 249.5' })}</LocationBadge>}
      <Text>Next Trunkshow:</Text>
      <Link href={`/custom-bespoke/trunk-shows/${handle}`}>
        <FormattedDateRange start={startDate} end={endDate} />
      </Link>
    </Root>
  )
}

UpcomingTrunkShow.propTypes = {
  handle: PropTypes.string,
  locationBadge: PropTypes.oneOf(['HK', 'NY', 'SH']),
  startDate: PropTypes.string,
  endDate: PropTypes.string,
}

UpcomingTrunkShow.defaultProps = {}

export default UpcomingTrunkShow
